import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 25px 100px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 30px;

    border-radius: 3px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    padding-left: 20px;
    color: white;
    font-size: 14px;
    weight: 200;
    outline: none;

    &:placeholder {
        color: #909fac;
    }
`;

export const ExercisesContainer = styled.div`
    width: 100%;
    height: 350px;
    overflow: auto;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/ChooseWorkoutTypeModal/style.js